import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/carCase';



// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:{};
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}


function getByIdReset(state, action) {
  state.getById.data={};
  state.getById.connection= false;
  state.getById.error= false;
  state.getById.message= "";
}

// CREATE
function create(state, action) {
  state.create.result = action.payload.result ? action.payload.result:false;
}

function conexionCreate(state, action) {
  state.create.connection= action.payload.connection;
}

function errorCreate(state, action) {
  state.create.error= action.payload.error ? action.payload.error:false;
  state.create.message= action.payload.message ? action.payload.message:"";
}

function createReset(state, action) {
  state.create.result=false;
  state.create.connection= false;
  state.create.error= false;
  state.create.message= "";
}

//UPDATE
function update(state, action) {
  state.update.result = action.payload.result ? action.payload.result:false;
}

function conexionUpdate(state, action) {
  state.update.connection= action.payload.connection;
}

function errorUpdate(state, action) {
  state.update.error= action.payload.error ? action.payload.error:false;
  state.update.message= action.payload.message ? action.payload.message:"";
}

function updateReset(state, action) {
  state.update.result=false;
  state.update.connection= false;
  state.update.error= false;
  state.update.message= "";
}

//UPDATE SATATUS
function updateStatus(state, action) {
  state.updateStatus.result = action.payload.result ? action.payload.result:false;
}

function conexionUpdateStatus(state, action) {
  state.updateStatus.connection= action.payload.connection;
}

function errorUpdateStatus(state, action) {
  state.updateStatus.error= action.payload.error ? action.payload.error:false;
  state.updateStatus.message= action.payload.message ? action.payload.message:"";
}

function updateStatusReset(state, action) {
  state.updateStatus.result=false;
  state.updateStatus.connection= false;
  state.updateStatus.error= false;
  state.updateStatus.message= "";
}

/**
 * Conexión
 */
const carCaseReducer = createSlice({
  name: 'carCase',
  initialState: initState,
  reducers: {
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    getByIdReset,
    // CREATE
    create,
    conexionCreate,
    errorCreate,
    createReset,
    //UPDATE
    update,
    conexionUpdate,
    errorUpdate,
    updateReset,
    //UPDATE SATATUS
    updateStatus,
    conexionUpdateStatus,
    errorUpdateStatus,
    updateStatusReset

    
  },
});

export const carCaseActions = {
  ...carCaseReducer.actions,
};

export default carCaseReducer.reducer;
